var _g, _path, _path2, _path3, _path4, _path5, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 69,
    viewBox: "0 0 57 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_4596_14688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.479 16.1695L26.7486 23.1112L18.1749 28.0628L16.5624 30.2169L18.984 52.0889L38.5453 42.8365L40.1582 40.6805L39.479 16.1695Z",
    fill: "#AF89FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6556 16.008L38.9432 16.6885L25.2312 40.4385L25.3324 40.8164L40.119 40.6657L39.6556 16.008Z",
    fill: "#E3D7F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6555 16.0082L18.0696 27.9357L25.3324 40.8166L31.9877 29.2892L39.6555 16.0082Z",
    fill: "#E0DFE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1278 42.9038L23.8959 42.9925L19.0116 51.4525L18.918 51.9274L38.92 42.7616L24.1278 42.9038Z",
    fill: "#9992A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9155 51.9291L24.1252 42.9056L16.8613 30.0266L18.9155 51.9291Z",
    fill: "#E2D7F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0695 27.9342L25.3322 40.8151L31.9876 29.2877L18.0695 27.9342Z",
    fill: "#9992A6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4596_14688",
    x: 0.5625,
    y: 0.169434,
    width: 55.5957,
    height: 67.9194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_4596_14688"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEth);
export default __webpack_public_path__ + "static/media/ic_eth.d14f344e0b253de1ac57e77d83e6f6fa.svg";
export { ForwardRef as ReactComponent };